/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../../google/protobuf/field_mask';
import '../resources/credit_line';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveCreditLineRequest": {
                "fields": {
                  "creditLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "excludeSlowFields": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "readMask": {
                    "type": ".google.protobuf.FieldMask",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveCreditLineResponse": {
                "fields": {
                  "creditLine": {
                    "type": ".squareup.corporate_card.resources.CreditLine",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCreditLineRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCreditLineResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveCreditLineRequest @ squareup/corporate_card/service/retrieve_credit_line.proto at 10:1
 */
export const RetrieveCreditLineRequest = $root.lookupType('squareup.corporate_card.service.RetrieveCreditLineRequest');
fixType(RetrieveCreditLineRequest);
Builder.createAndAttachToType(RetrieveCreditLineRequest);
/**
 * SOURCE RetrieveCreditLineResponse @ squareup/corporate_card/service/retrieve_credit_line.proto at 41:1
 */
export const RetrieveCreditLineResponse = $root.lookupType('squareup.corporate_card.service.RetrieveCreditLineResponse');
fixType(RetrieveCreditLineResponse);
Builder.createAndAttachToType(RetrieveCreditLineResponse);